module.exports = __webpack_public_path__ + "static/media/his.8efe5c50.gif";